import { Theme } from '@fluentui/react-components';

export const lightThemeV9: Partial<Theme> = {
  colorBrandForeground1: '#0078d4',
  colorBrandBackground2: '#eff6fc',
  colorBrandBackground: '#c7e0f4',
  colorBrandForeground2: '#106ebe',
  colorBrandForeground2Hover: '#005a9e',
  colorBrandForeground2Pressed: '#004578',
  colorBrandBackgroundHover: '#106ebe',
  colorBrandBackgroundPressed: '#005a9e',
  colorBrandBackground2Hover: '#deecf9',
  colorBrandBackground2Pressed: '#71afe5',
  colorNeutralBackground4: '#faf9f8',
  colorNeutralBackground3: '#f3f2f1',
  colorNeutralStroke2: '#edebe9',
  colorNeutralBackground2: '#e1dfdd',
  colorNeutralStroke3: '#d0d0d0',
  colorNeutralForeground2: '#605e5c',
  colorNeutralForeground1: '#323130',
  colorNeutralForeground3: '#201f1e',
  colorNeutralForeground4: '#000000',
  colorNeutralBackground1: '#ffffff',
};

export const darkThemeV9: Partial<Theme> = {
  colorBrandForeground1: '#74acd6',
  colorBrandBackground2: '#f9fbfd',
  colorBrandBackground: '#d1e4f3',
  colorBrandForeground2: '#689ac1',
  colorBrandForeground2Hover: '#5882a3',
  colorBrandForeground2Pressed: '#5882a3',
  colorBrandBackgroundHover: '#689ac1',
  colorBrandBackgroundPressed: '#5882a3',
  colorBrandBackground2Hover: '#e6f1f8',
  colorBrandBackground2Pressed: '#a7cbe7',
  colorNeutralBackground4: '#1b214d',
  colorNeutralBackground3: '#5c5854',
  colorNeutralStroke2: '#33312f',
  colorNeutralBackground2: '#232c66',
  colorNeutralStroke3: '#2a2928',
  colorNeutralForeground2: '#d0d0d0',
  colorNeutralForeground1: '#dadada',
  colorNeutralForeground3: '#f4f4f4',
  colorNeutralForeground4: '#f8f8f8',
  colorNeutralBackground1: '#2a2a2a',
};

export const lightThemeTeamsV9: Partial<Theme> = {
  colorBrandForeground1: '#6462a7',
  colorBrandBackground2: '#040407',
  colorBrandBackground: '#1e1d32',
  colorBrandForeground2: '#706eaf',
  colorBrandForeground2Hover: '#8381bb',
  colorBrandForeground2Pressed: '#a09ecd',
  colorBrandBackgroundHover: '#706eaf',
  colorBrandBackgroundPressed: '#8381bb',
  colorBrandBackground2Hover: '#10101b',
  colorBrandBackground2Pressed: '#1e1d32',
  colorNeutralBackground4: '#eeeeee',
  colorNeutralBackground3: '#eaeaea',
  colorNeutralStroke2: '#e1e1e1',
  colorNeutralBackground2: '#d1d1d1',
  colorNeutralStroke3: '#c8c8c8',
  colorNeutralForeground2: '#605e5c',
  colorNeutralForeground1: '#323130',
  colorNeutralForeground3: '#201f1e',
  colorNeutralForeground4: '#000000',
  colorNeutralBackground1: '#f5f5f5',
};

export const darkThemeTeamsV9: Partial<Theme> = {
  colorBrandForeground1: '#74acd6',
  colorBrandBackground2: '#f9fbfd',
  colorBrandBackground: '#d1e4f3',
  colorBrandForeground2: '#689ac1',
  colorBrandForeground2Hover: '#5882a3',
  colorBrandForeground2Pressed: '#416078',
  colorBrandBackgroundHover: '#689ac1',
  colorBrandBackgroundPressed: '#5882a3',
  colorBrandBackground2Hover: '#e6f1f8',
  colorBrandBackground2Pressed: '#a7cbe7',
  colorNeutralBackground4: '#1b214d',
  colorNeutralBackground3: '#5c5854',
  colorNeutralStroke2: '#33312f',
  colorNeutralBackground2: '#232c66',
  colorNeutralStroke3: '#2a2928',
  colorNeutralForeground2: '#d0d0d0',
  colorNeutralForeground1: '#dadada',
  colorNeutralForeground3: '#f4f4f4',
  colorNeutralForeground4: '#f8f8f8',
  colorNeutralBackground1: '#2a2a2a',
};
